const baseUrl = 'https://doctors-portal-21vz.onrender.com';
// const baseUrl = 'http://localhost:5000';

export default baseUrl;